import React from 'react'
import { Route } from 'react-router'
import Layout from './layout'
import {
  CourseStoryPage,
  ChapterOverviewPage,
  ChapterBlockPlayerPage,
  CourseCompletionPage,
} from '../views'

const Routes = (
  <Route component={Layout}>
    <Route path="course/:courseId" component={CourseStoryPage} />
    <Route path="course/:courseId/chapters" component={ChapterOverviewPage} />
    <Route
      path="course/:courseId/chapters/:chapterId/blocks/:blockId"
      component={ChapterBlockPlayerPage}
    />
    <Route
      path="course/:courseId/certificate"
      component={CourseCompletionPage}
    />
  </Route>
)

export default Routes
